import { format } from 'date-fns'

export function dataFormatter(value, localeDateFns = 'enUS') {
  if (!value && value !== 0) return ''

  let dateObj

  try {
    if (typeof value === 'string' && value.includes('-')) {
      const parts = value.split('-')
      if (parts.length !== 3) return ''

      const [year, month, day] = parts.map(Number)
      if (isNaN(year) || isNaN(month) || isNaN(day)) return ''

      dateObj = new Date(year, month - 1, day)
    } else {
      dateObj = new Date(value)
    }

    if (isNaN(dateObj.getTime())) return ''

    return format(dateObj, 'dd/MM', {
      locale: localeDateFns || 'enUS',
    })
  } catch (error) {
    return ''
  }
}
